<div class="warnMessage" *ngIf="duplicates?.length > 0">
    <span *ngIf="duplicates.length === 1">{{'cs.sys.duplicates.check.foundOneDuplicate.' + duplicatesMessageSuffix | hisUi}}</span>
    <span *ngIf="duplicates.length > 1">{{'cs.sys.duplicates.check.foundDuplicates.' + duplicatesMessageSuffix | hisUi: duplicates.length}}</span>
    <br>
    <ul class="listSimple">
        <li *ngFor="let duplicate of duplicates">
            <a routerLink="{{route}}/{{duplicate.id}}"
               [queryParams]="{showSearchButton: true, showBackButton: true}"
               hisImage="magnifier_detail"
               title="{{'common.showOf' | hisUi: (duplicate.name)}}"
               (click)="onClick()">{{ duplicate.description }}</a>
        </li>
    </ul>
</div>
